<template>
  <div class="view companies">
    <section class="banner">
      <div class="banner-background">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1298" viewBox="0 0 1900 1298"><defs><linearGradient id="cpb-a" x1="1" y1="-0.061" x2="0.153" y2="0.973" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.892" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient><clipPath id="cpb-b"><rect width="1900" height="1298" fill="#fff"/></clipPath><linearGradient id="cpb-c" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="cpb-e" x="-996.427" y="-1678.665" width="3024.7" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="f"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><filter id="cpb-g" x="1604.653" y="329.564" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="h"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter><filter id="cpb-i" x="1392.572" y="218.542" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="j"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="j"/><feComposite in="SourceGraphic"/></filter><filter id="cpb-k" x="1433.652" y="308.5" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="l"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="l"/><feComposite in="SourceGraphic"/></filter><filter id="cpb-m" x="877.5" y="687.5" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="n"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="n"/><feComposite in="SourceGraphic"/></filter><filter id="cpb-o" x="815.5" y="648.5" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="p"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="p"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-535.239 -111)" opacity="0.081"><path d="M78.092,0C116.03-2.708,151.75,26.327,151.75,72.167s-37.286,79.172-81.057,86.5S0,128.84,0,83,40.155,2.708,78.092,0Z" transform="translate(854.495 882)" fill="url(#cpb-a)"/><path d="M24.986.714C37.1.243,48.762,9.04,49.128,22.449s-11.3,22.844-25.242,24.616S1.03,37.741.664,24.331,12.87,1.184,24.986.714Z" transform="translate(1029.835 930.332) rotate(-121)" fill="#019edf"/><path d="M15.644.031C23.244-.449,30.4,4.7,30.4,12.829s-7.469,14.04-16.238,15.34S0,22.879,0,14.75,8.044.511,15.644.031Z" transform="translate(814.633 930.527) rotate(-90)" fill="#099aa8"/><ellipse cx="6.586" cy="7" rx="6.586" ry="7" transform="translate(873.312 1049)" fill="#0d988c"/></g><g clip-path="url(#cpb-b)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#cpb-c)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#cpb-e)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#cpb-c)"/></g></g><g transform="translate(0 -100)"><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cpb-g)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1641.75, 374.91)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cpb-i)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1427.71, 257.33)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cpb-k)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(1462.15 325)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cpb-m)"><circle cx="8" cy="8" r="8" transform="translate(906 704)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#cpb-o)"><circle cx="17" cy="17" r="17" transform="translate(844 665)" fill="#00a1ed"/></g></g></svg>
      </div>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="191.434" height="199.511" viewBox="0 0 191.434 199.511"><defs><filter id="chs-a" x="0" y="0" width="177.89" height="184.54" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="chs-c" x="119.434" y="39.511" width="72" height="72" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="chs-e" x="21.434" y="127.511" width="72" height="72" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-317.066 -316.989)"><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#chs-a)"><path d="M71.59-7.113C113.855-11.551,96.762,21.832,120,60s-3.5,74.168-54.793,54.457S-4.125,96.16,15.039,60,29.324-2.676,71.59-7.113Z" transform="translate(20.93 24.01)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#chs-c)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(147.93 56.01)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 317.07, 316.99)" filter="url(#chs-e)"><circle cx="7.5" cy="7.5" r="7.5" transform="translate(49.93 144.01)" fill="#00a1ed"/></g></g></svg>
          <h1>Companies</h1>
          <p v-if="!companies.length">There are no companies registered yet. Come back soon to see more updates.</p>
        </div>
      </div>
      <!-- <div class="support">
        <img src="@/assets/cast_logo_simple.svg" alt="CAST Network">
        <router-link to="/register" class="btn">Get Support</router-link>
      </div> -->
    </section>
    <section class="companies-list">
      <div class="wrapper" :empty="!companies.length">
        <router-link class="company" v-for="company in companies" :to="`/companies/${company.id}`" :key="company.id">
          <div class="company-logo" :style="{backgroundImage: `url(${company.image})`}"></div>
          <div class="company-name">{{company.name}}</div>
          <div class="company-types">
            <span class="company-type" v-for="type in company.types" :key="`type-${company.id}-${type}`" :style="{color: colors[type]}">{{type}}</span>
          </div>
        </router-link>
        <div class="company">
          <div class="company-logo" :style="{backgroundImage: `url(${require('@/assets/cast_logo_simple.svg')})`}"></div>
          <div class="company-name">Are you a startup or an SME?</div>
          <router-link to="/register" class="btn">Get support</router-link>
        </div>
      </div>
    </section>
    <Newsletter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Newsletter from '../components/Newsletter'

export default {
  name: 'companies',
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    })
  },
  components: {
    Newsletter
  },
  data() {
    return {
      companies: [],
      colors: {
        'Incubator': '#0D988C',
        'Investor Network': '#8ABB2A',
        'Cluster': '#880F50',
        'Chamber of Commerce': '#D4177C',
        'Accelerator': '#FFD400',
        'Development Centre': '#F77E0B',
        'Association': '#E77323',
        'Foundation': '#BCBCCB',
        'BIC': '#00A1ED',
        'Non-profit': '#343434'
      },
    }
  },
  mounted: function() {
    this.companiesRef = this.db().collection('companies').where('status', '==', 'accepted').onSnapshot(companies => {
      this.companies = companies.docs.map(company => company.data())
      this.$store.commit('setPageLoading', false)
    })
  },
  beforeDestroy: function() {
    if(this.companiesRef) this.companiesRef()
  }
}
</script>

<style scoped>
.companies {
  /* background: url(../assets/cast_partners_banner.jpg) no-repeat top center/1920px auto; */
  padding-top: 222px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .banner-bubbles {
  position: absolute;
  top: 225px;
  right: 198px;
  width: 838px;
  height: 505px;
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 800px;
}

.page-title svg {
  position: absolute;
  top: -48px;
  left: 120px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #fff;
}

.banner .picture-alt {
  margin-top: 10px;
  text-align: center;
  color: #BCBCCB;
  text-transform: uppercase;
  letter-spacing: .58em;
  font-size: .72em;
}

.support {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 256px;
  height: 256px;
  margin: 72px auto;
  background: #fff;
  border-radius: 50%;
  text-align: center;
  box-shadow: 0 14px 28px rgba(0,0,0,.05);
}

.support img {
  display: block;
  width: 102px;
}

.support .btn {
  margin-top: 26px;
  flex-grow: 0;
  min-width: 0;
  width: 120px;
  height: 36px;
  padding: 0;
  font-size: .79em;
}

.section-description {
  position: relative;
}

.section-description svg {
  position: absolute;
  top: -210px;
  left: 0;
}

section h2 {
  font: bold 3.21em/1 'Butler';
}

section h2:after {
  content: '';
  display: block;
  width: 74px;
  height: 1px;
  background: currentColor;
  margin-top: 20px;
}

.companies-list {
  margin: 96px -8px 48px;
}

.companies-list .wrapper {
  display: flex;
  flex-flow: row wrap;
}

.companies-list .wrapper[empty] {
  justify-content: center;
}

.company {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: calc(25% - 16px);
  height: 280px;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0,0,0,.06);
  background: #fff;
  margin: 0 8px 54px;
  padding: 0 24px;
  transition: box-shadow .16s ease-out;
}

@media screen and (min-width: 1025px) {
  .company:hover {
    box-shadow: 0 12px 24px rgba(0,0,0,.12);
  }
}

.company .company-logo {
  width: 60%;
  height: 96px;
  margin: 0 auto 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.company .company-name {
  font-size: 16px;
  text-align: center;
  margin-bottom: 8px;
  color: #00A1ED;
}

.company .company-types {
  text-align: center;
}

.company .company-type {
  display: inline-block;
  font-size: 10px;
  border: 1px solid;
  padding: 2px 8px;
  border-radius: 11px;
  margin: 4px 4px 0;
}

.company .btn {
  min-width: 0;
  width: 120px;
  height: 36px;
  padding: 0;
  font-size: .79em;
}

@media screen and (max-width: 1180px) {
  .company {
    width: calc(33.333333% - 16px);
  }
}

@media screen and (max-width: 1024px) {
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color:#00A1ED;
  }
  .page-title p {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #00A1ED;
  }
  .banner .picture-alt {
    display: none;
  }
  .companies-list {
    margin-top: 72px;
  }
}

@media screen and (max-width: 900px) {
  .company {
    width: calc(50% - 16px);
  }
}

@media screen and (max-width: 680px) {
  .companies {
    padding-top: 172px;
  }
}

@media screen and (max-width: 620px) {
  .company {
    width: 100%;
    max-width: 360px;
    margin: 0 auto 48px;
  }
}
</style>
